interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  titles?: string[]; // Optional: if you want to display titles for steps
}

export default function ProgressBar({
  currentStep,
  totalSteps,
  titles,
}: ProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100

  return (
    <div className="space-y-2 mb-6">
      {titles && titles.length > 0 && (
        <div className="text-center text-sm font-medium text-gray-700">
          {/* Display current step title if available */}
          {titles[currentStep - 1] || `Step ${currentStep}`}
        </div>
      )}
      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
        <div
          className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400">
        <span>
          Step {currentStep} of {totalSteps}
        </span>
        <span>{Math.round(progress)}% Complete</span>
      </div>
    </div>
  )
}
